"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClerkProvider = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const errors_1 = require("../errors");
const utils_1 = require("../utils");
const ClerkContextProvider_1 = require("./ClerkContextProvider");
const StructureContext_1 = require("./StructureContext");
function ClerkProviderBase(props) {
    const { initialState, children, Clerk, frontendApi } = props, options = tslib_1.__rest(props, ["initialState", "children", "Clerk", "frontendApi"]);
    return (react_1.default.createElement(StructureContext_1.StructureContext.Provider, { value: StructureContext_1.StructureContextStates.noGuarantees },
        react_1.default.createElement(ClerkContextProvider_1.ClerkContextProvider, { initialState: initialState, isomorphicClerkOptions: { frontendApi: frontendApi || '', Clerk, options } }, children)));
}
const ClerkProvider = (0, utils_1.withMaxAllowedInstancesGuard)(ClerkProviderBase, 'ClerkProvider', errors_1.multipleClerkProvidersError);
exports.ClerkProvider = ClerkProvider;
ClerkProvider.displayName = 'ClerkProvider';
//# sourceMappingURL=ClerkProvider.js.map